module.exports = __webpack_public_path__ + "GU.png?192f08e02ec17c9eb14a4e15f74182ad";